import antd from 'ant-design-vue/es/locale-provider/de_DE';
import dayjsLocale from 'dayjs/locale/de';
import momentEnCA from 'moment/dist/locale/en-ca';
import data from '../json/de.json';

const components = {
  antLocale: antd,
  momentName: 'eu',
  momentLocale: momentEnCA,
  dayjsName: 'eu',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
